import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
	List,
	ListItem,
	ListItemAvatar,
	Avatar,
	ListItemText,
	ListItemSecondaryAction,
	TextField,
	IconButton
} from '@material-ui/core';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { borders } from '@material-ui/system';
import SendIcon from '@material-ui/icons/SendRounded';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import { GET_POINTS, CLEAR_POINTS, SHOW_TOAST } from "../../store/actions/types";
// Redux
import { connect } from 'react-redux';
import {
	createNewComment,
	createNewSubComment,
	deleteComment,
	deleteSubComment
} from '../../store/actions/commentActions';
import { addMorePoints } from '../../store/actions/freshCardActions'
import { getRealPoints } from '../../store/actions/realPointsActions'
import { POINT_CONFIG } from '../../utils/point_conversion_utils';
import { checkActivationStatus } from '../../utils/user_activation_utils';
import {
	isMobile,
	isBrowser
  } from 'react-device-detect'
import { showToast } from '../../store/actions/toastAction'
import firebase from './../../store/firebase';

const styles = {
	root: {
		listStyle: 'none !important',
		justifyContent: 'left',
		position: 'relative',
        display: 'flex'
	},
	nested: {
		paddingLeft: '0px',
		justifyContent: 'left',
		position: 'relative',
        display: 'flex'
	}
};

	function makeid(length) {
		var result           = '';
		var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() * 
	charactersLength));
		}
		return result;
	}

const AddComment = (props) => {
	const { commentText, onCommentTextChange, isSubComment, parentID, onSendComment, classes } = props;
	return (
		<ListItem
			style={isSubComment ? styles.root : styles.root}
			//className={isSubComment ? classNames(styles) : null}
			ContainerComponent="div"
		>
			<ListItemAvatar>
				<Avatar alt={props.userdata.firstName} src={props.userdata.photoURL} />
			</ListItemAvatar>
			<ListItemText>
				 <TextareaAutosize
					value={commentText}
					onChange={(e) => onCommentTextChange(e.target.value)}
					fullWidth
					placeholder="Leave a comment"
					style={{
					    borderTop: 'none', 
						borderLeft: 'none', 
						borderRight: 'none', 
						resize: 'none', 
						width: isMobile ? '180px' : '340px',
						minWidth: isMobile ? '140px' : '290px',
						maxWidth: isMobile ? '190px' : '360px',
						outline: 'none'
					}}
				/>	
			</ListItemText>
			<ListItemSecondaryAction
				style={{ 
					width: isMobile ? '50px' : '60px', 
					minWidth: isMobile ? '30px' : '40px',
					maxWidth: isMobile ? '60px' : '80px',
					}}
			>
				<IconButton onClick={onSendComment} aria-label="SendComment"
				>
					<SendIcon />
				</IconButton>
			</ListItemSecondaryAction>
		</ListItem>
	);
};
class AddCommentField extends Component {
	constructor(props) {
		super(props)
	  }

	state = {
		comment: ''
	};

	componentDidMount() {
		const { userdata, post, rrpoints } = this.props;
		// if (this.props.post.uid) {
		//   var pdata = {
		//   type: "GET_POINTS",
		//   uid: this.props.post.uid
		// }
		// this.props.getRealPoints(pdata);
		// }

	  }

	handleCommentChange = (value) => {
		this.setState((prevState) => ({
			comment: value
		}));
	};

	pointsPass = (dbPoints, realPoints) => {
		var pass = false;
		if (dbPoints < realPoints) {
		  if (parseInt(realPoints) - parseInt(dbPoints) < 3) { 
			pass = true;
		  }
		} else
		{
		  if (parseInt(dbPoints) - parseInt(realPoints) < 3) { //too big - CANCEL
			pass = true;
		  } 
		}
		return pass;
	  }

	handleSendComment = async (e) => {
		const { userdata, postType, post, isSubComment, parentID, showLeadb } = this.props;
		
		// Validate comment is not empty before proceeding
		if (!this.state.comment || !this.state.comment.trim()) {
			this.props.showToast({
				type: 'SHOW_TOAST',
				open: true,
				variant: 'warning',
				message: 'Please enter your comment!'
			});
			return;
		}

		let commentParams = {
			postType: postType,
			comment: this.state.comment
		};

		// Get post author's current points from database
		let authorPoints, authorPointsy = 0;
		try {
			await firebase.database
				.ref('user/' + post.uid)
				.once('value', function (snapshot) {
					try {
						if (snapshot.val() && snapshot.val().points) {
							authorPoints = snapshot.val().points;
							authorPointsy = snapshot.val().pointsy || 0;
						}
					} catch (error) {
						// Error getting author points
					}
				});
		} catch (error) {
			// Error connecting to database
		}

		// Create comment first
		if (!isSubComment) {
			this.props.createNewComment(post, userdata, commentParams);
		} else {
			commentParams.parentID = parentID;
			this.props.createNewSubComment(post, userdata, commentParams);
		}

		// Distribute points based on activation status
		if (userdata.userID !== this.props.post.journalUserID && authorPoints !== undefined) {
			
			// Check activation status for both owner and user
			const ownerData = {
				execmember: this.props.post.execmember,
				userType: this.props.post.userType,
				points: authorPoints
			};
			
			const userData = {
				execmember: userdata.execmember,
				userType: userdata.userType,
				points: userdata.points
			};
			
			const { ownerActivated, userActivated, scenario } = checkActivationStatus(ownerData, userData);
			
			// Scenario 1: Owner activated & user activated → normal 70/30% distribution
			// Scenario 2: Owner activated & user NOT activated → Owner gets 70%, user gets nothing  
			// Scenario 3: Owner not activated → nobody gets points
			
			if (scenario === 'both_activated' || scenario === 'owner_only') {
				// Give points to the owner (author) in both scenarios
				let authorData = {
					uid: this.props.post.uid,
					userID: this.props.post.journalUserID,
					pointsCurrent: authorPoints,
					ypointsCurrent: authorPointsy,
					leadPoints: this.props.post.leadPoints ? this.props.post.leadPoints : 0,
					pointsAdded: POINT_CONFIG.COMMENT_AUTHOR_POINTS,
					trailID: makeid(10),
					companyName: this.props.post.companyName,
					firstName: this.props.post.journalUserName,
					lastName: "empty",
					title: this.state.comment,
					actionType: "Comment received",
					actionDesc: "LEAD comment received",
					currentUser: userdata.userID,
					leadID: this.props.post.dailyThoughtID ? this.props.post.dailyThoughtID : "",
					groupid: this.props.post.groupid ? this.props.post.groupid : '',
					forceAward: true
				};

				this.props.addMorePoints(authorData);
			}

			if (scenario === 'both_activated') {
				// Only give points to the commenter if both are activated
				// Fallback to known userdata points if the DB node doesn't exist
				const commenterCurrentPoints = (typeof userdata.points === 'number' ? userdata.points : 0) || 0;
				const commenterCurrentPointsy = (typeof userdata.pointsy === 'number' ? userdata.pointsy : 0) || 0;

				let commenterData = {
					uid: userdata.uid,
					userID: userdata.userID,
					pointsCurrent: commenterCurrentPoints,
					ypointsCurrent: commenterCurrentPointsy,
					leadPoints: 0, // Commenter doesn't affect lead points
					pointsAdded: POINT_CONFIG.COMMENT_LIKER_POINTS,
					trailID: makeid(10),
					companyName: userdata.companyName,
					firstName: userdata.firstName,
					lastName: userdata.lastName || "empty",
					title: "Comment given",
					actionType: "Comment given",
					actionDesc: "LEAD comment given",
					currentUser: userdata.userID,
					leadID: this.props.post.dailyThoughtID ? this.props.post.dailyThoughtID : "",
					groupid: this.props.post.groupid ? this.props.post.groupid : '',
					forceAward: true
				};

				this.props.addMorePoints(commenterData);
			}
		}

		if (this.props.showLeadb) {
			showLeadb(this.props.post, POINT_CONFIG.COMMENT_AUTHOR_POINTS);
		}

		this.setState((prevState) => ({
			comment: ''
		}));
	}

	render() {
		const { comment } = this.state;
		const { isSubComment, parentID, showLeadb } = this.props;
		
		return (
			<AddComment
				onSendComment={this.handleSendComment}
				onCommentTextChange={this.handleCommentChange}
				showLeadb={showLeadb? showLeadb: ''}
				commentText={comment}
				parentID={parentID}
				{...this.props}
			/>
		);
	}
 
}
//AddCommentField.propTypes = {};
AddCommentField.propTypes = {
	classes: PropTypes.object.isRequired,
	fullScreen: PropTypes.bool.isRequired
  }
// const mapDispatchToProps = dispatch => {
// 	return {
// 	  addMorePoints: params => dispatch(addMorePoints(params)),
// 	  createNewComment: params => dispatch(createNewComment(params)),
// 	  createNewSubComment: params => dispatch(createNewSubComment(params)),
// 	  deleteComment: params => dispatch(deleteComment(params)),
// 	  deleteSubComment: params => dispatch(deleteSubComment(params)),
// 	}
//   }
const mapStateToProps = (state) => {
	return {
		comments: state.comments,
		userdata: state.userDialog.userDetails[0],
		rrpoints: state.realpoints.realpoints
	};
};
// export default connect(
// 	mapStateToProps,
// 	mapDispatchToProps,
//   )(AddCommentField)

export default connect(mapStateToProps, { createNewComment, createNewSubComment, addMorePoints, getRealPoints, showToast })(AddCommentField);
